import React, {useState} from "react";
import useTablePagination from "../../hooks/useTablePagination";
import {getRolesTable} from "./rolesApi";
import {DataGrid} from "@mui/x-data-grid";
import {Box, IconButton,} from "@mui/material";
import LockPersonRoundedIcon from '@mui/icons-material/LockPersonRounded';
import EditRolePermissionsDialog from "./EditRolePermissionsDialog";

const filterModel = {
    like:[],
    in:['type','assignee'],
    where:[],
    date:[],
    custom:{
        search:{
            getter:(filters,filtersSearch)=>{
                filters['search'] =  filtersSearch.getAll('search');
            },
            setter:(queryParams,key,val)=>{
                queryParams.append("search",val);
            }
        }
    }
};

function generateRows(row, tableFilters){
    return ({
        ...row,
        updated_at:new Date(row.updated_at)
    })
}

export default function Table(){
    const [openEditPermission,setOpenEditPermission] = useState({
        open:false,rowId:null
    });
    const {
        dataGridOptions,
    } = useTablePagination(
        [
            { field: 'id', headerName: 'ID', width: 150 ,sortable:false},
            { field: 'name', headerName: 'Name', flex:1,minWidth:150 },
            { field: 'guard_name', headerName: 'Guard name', width: 150 ,sortable:false},
            { field: 'updated_at',headerName: 'Updated at',flex:1,width: 150,type:'dateTime',sortable:false},
            { field: 'action', headerName: 'Action', width: 100,sortable:false,headerAlign:'center',
                renderCell:({row})=>(<Box
                    display={'flex'}
                    onClick={(e)=>{
                        e.stopPropagation();
                    }}
                    width={'100%'}
                    justifyContent={'center'}
                >
                    {/*<IconButton*/}
                    {/*    size={'small'}*/}
                    {/*    onClick={()=>{*/}
                    {/*        */}
                    {/*        setOpenEdit(prevState => !prevState)*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    */}
                    {/*    <EditRoundedIcon fontSize={'small'} />*/}
                    {/*</IconButton>*/}
                    <IconButton
                        size={'small'}
                        onClick={()=>{
                            
                            setOpenEditPermission(prevState => ({
                                rowId: row.id,
                                open: !prevState.open    
                            }))
                        }}
                    >
                        <LockPersonRoundedIcon fontSize={'small'} />
                    </IconButton>
                </Box>)
            },
        ],
        generateRows,
        filterModel,
        getRolesTable,
    );
    return <Box sx={{
        height:`calc(100vh - 300px)`,
        minHeight:400,
        pt:2,
        width:'100%'
    }}>
        <DataGrid
            sx={{
                '& .MuiDataGrid-main>*:first-of-type':{
                    borderRadius:0
                }
            }}
            disableColumnFilter
            {...dataGridOptions}
        />
        <EditRolePermissionsDialog 
            open={openEditPermission.open} 
            setOpen={setOpenEditPermission}
            rowId={openEditPermission.rowId}
        />
        {/*<Dialog open={openEdit} onClose={()=>setOpenEdit(false)}>*/}
        {/*    <DialogTitle>*/}
        {/*        Edit permission*/}
        {/*    </DialogTitle>*/}
        {/*    <DialogContent sx={{minWidth:400}}>*/}
        {/*        <Grid container py={2} spacing={2}>*/}
        {/*            <Grid item xs={12}>*/}
        {/*                <TextField label={"Display name"} fullWidth  />*/}
        {/*            </Grid>*/}
        {/*            <Grid item xs={12}>*/}
        {/*                <TextField label={"Description"} multiline rows={3} fullWidth  />*/}
        {/*            </Grid>*/}
        {/*        </Grid>*/}
        {/*    </DialogContent>*/}
        {/*    <DialogActions>*/}
        {/*        <Button color={"error"} onClick={()=>setOpenEdit(false)}>*/}
        {/*            Close*/}
        {/*        </Button>*/}
        {/*        <Button color={"success"} onClick={()=>setOpenEdit(false)}>*/}
        {/*            Save*/}
        {/*        </Button>*/}
        {/*    </DialogActions>*/}
        {/*</Dialog>*/}
    </Box>
}